import React from 'react';
import ThankYou, { useOnThankYouClick } from './thank-you-form';
import CommonElements from './common-elements';
import { enroll } from '@openstax/experiments';
import useGiveLinks from './use-give-links';
import './give-before-pdf.scss';
export default function GiveBeforePdf({ link, track, close, data, onDownload, id }) {
    const [doneDownloading, setDoneDownloading] = React.useState(false);
    const { showThankYou, onThankYouClick } = useOnThankYouClick();
    React.useEffect(() => {
        window.setTimeout(() => setDoneDownloading(true), 700);
    }, []);
    if (!data.download_ready || !doneDownloading) {
        return React.createElement(Downloading, { data: data });
    }
    if (showThankYou) {
        return React.createElement(ThankYou, { link: link, close: close, source: 'PDF download', track: track, id: id });
    }
    return (React.createElement(GiveBeforePdfAfterConditionals, { onThankYouClick, link, track, data, close, onDownload }));
}
function Downloading({ data }) {
    return (React.createElement("div", { className: 'give-before-pdf loading' },
        React.createElement("img", { src: data.download_image, alt: '', height: '50' }),
        React.createElement("p", null, "Downloading...")));
}
function GiveBeforePdfAfterConditionals({ onThankYouClick, link, track, data, close, onDownload }) {
    const [controlLink, alternateLink] = useGiveLinks();
    const variants = [
        {
            name: 'control',
            headerSubtitle: data.header_subtitle,
            giveLink: controlLink
        },
        {
            name: 'public good',
            headerSubtitle: 'Join us in sustaining OpenStax as a public good for years to come by giving today.',
            giveLink: alternateLink
        }
    ];
    const donationExperiment = enroll({
        name: 'Donation Experiment 2023',
        variants
    });
    React.useEffect(() => {
        window.dataLayer || (window.dataLayer = []);
        window.dataLayer.push({
            event: 'optimize.giveBeforePdf'
        });
    });
    const closeAfterDelay = React.useCallback((event) => {
        if (onDownload) {
            onDownload(event);
        }
        window.setTimeout(close, 200);
    }, [close, onDownload]);
    return (React.createElement("div", { className: 'give-before-pdf', "data-analytics-view": true, "data-analytics-nudge": 'donate', "data-nudge-placement": 'PDF download' },
        React.createElement("img", { className: 'download-icon', src: data.download_image, alt: '' }),
        React.createElement("h1", { id: "dialog-heading" }, data.download_ready),
        React.createElement("hr", null),
        React.createElement(CommonElements, { onThankYouClick: onThankYouClick, data: data, giveLink: donationExperiment.giveLink, headerSubtitle: donationExperiment.headerSubtitle }),
        React.createElement("a", Object.assign({ href: link }, (track ? { 'data-track': track } : {}), { onClick: closeAfterDelay, className: 'btn go-to' }), "Go to your file")));
}
